export enum CreditCheckType {
  SOFT = 'SOFT',
  HARD = 'HARD',
  SOFT_MANUAL = 'SOFT_MANUAL',
  HARD_MANUAL = 'HARD_MANUAL',
}

export interface CreditCheckResult {
  type: CreditCheckType.SOFT | CreditCheckType.HARD | CreditCheckType.SOFT_MANUAL | CreditCheckType.HARD_MANUAL;
  referenceNumber: string;
  creditScore: number;
  dateOfSearch: string;
}
